import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const serviceItemsRoutes: Routes = [
  {
    path: 'service-items',
    title: 'Leistungen',
    loadComponent: () =>
      import('./service-items-list/service-items-list').then(m => m.ServiceItemsListComponent),
    canActivate: [authGuard],
  },
  {
    path: 'service-items/new',
    title: 'Neue Leistung',
    loadComponent: () =>
      import('./service-item-form/service-item-form').then(m => m.ServiceItemFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'service-items/:id/edit',
    title: 'Leistung bearbeiten',
    loadComponent: () =>
      import('./service-item-form/service-item-form').then(m => m.ServiceItemFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
];
